import type { FC } from "react";

import { QueryClient, QueryClientProvider } from "@jti/rest-api";
import { PromotionCodes } from "@jti/ui/components/PromotionCodes";

import type { promotionInputs } from "./Promotion.builder";

type PromotionBuilderProps = BuilderComponentProps<typeof promotionInputs>;

const queryClient = new QueryClient();

export const Promotion: FC<PromotionBuilderProps> = ({
  successMessage,
  errorMessage,
  title,
  description,
  providers,
}) => {
  return (
    <QueryClientProvider client={queryClient}>
      <PromotionCodes
        title={title}
        description={description}
        successMessage={successMessage}
        errorMessage={errorMessage}
        promotions={providers}
      />
    </QueryClientProvider>
  );
};
